(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["floating-upload-now"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const buttons = document.querySelectorAll('[data-floating-upload-now]');

    buttons.forEach((button) => {
      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let startLeft = 0;
      let startTop = 0;
      let moved = false;
      let dragged = false;

      const margin = 12;
      const visiblePeek = 18;

      const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

      const getBounds = () => {
        const rect = button.getBoundingClientRect();
        return {
          rect,
          maxLeft: window.innerWidth - rect.width - margin,
          maxTop: window.innerHeight - rect.height - margin - 72,
        };
      };

      const setPosition = (left, top) => {
        button.style.setProperty('--floating-upload-x', `${left}px`);
        button.style.setProperty('--floating-upload-y', `${top}px`);
        button.style.setProperty('--floating-upload-bottom', 'auto');
      };

      const expand = () => {
        button.classList.remove('is-edge-hidden');
        button.setAttribute('aria-expanded', 'true');
      };

      const collapseToEdge = () => {
        const { rect, maxLeft, maxTop } = getBounds();
        const currentLeft = rect.left;
        const currentTop = clamp(rect.top, margin, maxTop);
        const edge = currentLeft + rect.width / 2 < window.innerWidth / 2 ? 'left' : 'right';
        const edgeLeft = edge === 'left' ? margin : maxLeft;

        button.dataset.edge = edge;
        setPosition(edgeLeft, currentTop);
        button.classList.add('is-edge-hidden');
        button.setAttribute('aria-expanded', 'false');
      };

      const onPointerMove = (event) => {
        if (!mobileQuery.matches || event.pointerId !== pointerId) {
          return;
        }

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (Math.abs(deltaX) > 4 || Math.abs(deltaY) > 4) {
          moved = true;
          dragged = true;
          button.classList.add('is-dragging');
          expand();
        }

        if (!moved) {
          return;
        }

        event.preventDefault();

        const { maxLeft, maxTop } = getBounds();
        const nextLeft = clamp(startLeft + deltaX, margin - visiblePeek, maxLeft + visiblePeek);
        const nextTop = clamp(startTop + deltaY, margin, maxTop);
        setPosition(nextLeft, nextTop);
      };

      const onPointerUp = (event) => {
        if (event.pointerId !== pointerId) {
          return;
        }

        pointerId = null;
        button.releasePointerCapture?.(event.pointerId);
        button.classList.remove('is-dragging');

        if (dragged) {
          event.preventDefault();
          collapseToEdge();
          setTimeout(() => {
            dragged = false;
          }, 0);
        }
      };

      button.addEventListener('pointerdown', (event) => {
        if (!mobileQuery.matches) {
          return;
        }

        pointerId = event.pointerId;
        moved = false;
        dragged = false;
        button.setPointerCapture?.(event.pointerId);

        const rect = button.getBoundingClientRect();
        startX = event.clientX;
        startY = event.clientY;
        startLeft = rect.left;
        startTop = rect.top;
      });

      button.addEventListener('pointermove', onPointerMove);
      button.addEventListener('pointerup', onPointerUp);
      button.addEventListener('pointercancel', onPointerUp);

      button.addEventListener('click', (event) => {
        if (!mobileQuery.matches) {
          return;
        }

        if (dragged) {
          event.preventDefault();
          return;
        }

        if (button.classList.contains('is-edge-hidden')) {
          event.preventDefault();
          expand();
        }
      });

      window.addEventListener('resize', () => {
        if (!mobileQuery.matches || !button.classList.contains('is-edge-hidden')) {
          return;
        }

        collapseToEdge();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerIsCover = this.getAttribute('data-sticky-type') === 'cover-logo-size';

      this.headerBounds = {};
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      if (this.headerIsCover) {
        this.header.classList.add('shopify-section-header-cover');
        
        const stickyHeader = document.querySelector('.header-wrapper');
        stickyHeader.classList.add('header-hovered');

        window.addEventListener('scroll', () => {
          let scrollTop =  document.documentElement.scrollTop;

          if (scrollTop > 650) {
            stickyHeader.classList.remove('header-hovered');
          } else {
            stickyHeader.classList.add('header-hovered');
          }
        });

      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      if (this.headerIsCover) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => {
				if (disclosure) {
					disclosure.close()
				}
			}
			);
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
